export default __webpack_public_path__ + "img/default-avatar.5e29effa.jpg";